
import React, { useRef } from 'react'
import { useGLTF,useTexture } from '@react-three/drei'
import {  useFrame } from '@react-three/fiber'

export default function Fan(props) {
  const { nodes, materials } = useGLTF('./models/fan01.gltf')
  const colors = props.colors
  const [matCap, matCap2] = useTexture([
    'img/matcap.jpg',
    'img/matcap2.jpg'
  ])
  
  const fanGroup =useRef()

  useFrame(()=>{

    fanGroup.current.rotation.z += 0.06

  }
    
  )

  return (
    <group {...props} dispose={null}>
      <mesh
        geometry={nodes.Sweep.geometry}
        material={nodes.Sweep.material}
        >
        <meshMatcapMaterial matcap={matCap} color={props.isDark?colors.night:colors.day} />
      </mesh>
      <mesh
        geometry={nodes.Disc1.geometry}
        material={nodes.Disc1.material}
        position={[0, 0.025, -0.018]}
        >
        <meshMatcapMaterial matcap={matCap2} color={props.isDark?colors.night2:colors.day2} />
      </mesh>
      <mesh
        geometry={nodes.Disc.geometry}
        material={nodes.Disc.material}
        position={[0, 0.025, -0.004]}>
        <group position={[0, 0, -0.002]} ref={fanGroup} >
          <mesh
            geometry={nodes.Plane_0.geometry}
            material={nodes.Plane_0.material}
            position={[0, 0.001, 0]}
            rotation={[0, -0.559, -Math.PI / 2]}
            >
            <meshMatcapMaterial matcap={matCap2} color={props.isDark?colors.night:colors.day} />
          </mesh>
          <mesh

            geometry={nodes.Plane_1.geometry}
            material={nodes.Plane_1.material}
            position={[0.001, 0.001, 0]}
            rotation={[-0.496, -0.268, -2.686]}
            >
            <meshMatcapMaterial matcap={matCap2} color={props.isDark?colors.night:colors.day} />
          </mesh>
          <mesh

            geometry={nodes.Plane_2.geometry}
            material={nodes.Plane_2.material}
            position={[0.001, -0.001, 0]}
            rotation={[-0.496, 0.268, 2.686]}
            >
            <meshMatcapMaterial matcap={matCap2} color={props.isDark?colors.night:colors.day} />
          </mesh>
          <mesh
 
            geometry={nodes.Plane_3.geometry}
            material={nodes.Plane_3.material}
            position={[0, -0.001, 0]}
            rotation={[0, 0.559, Math.PI / 2]}
            >
            <meshMatcapMaterial matcap={matCap2} color={props.isDark?colors.night:colors.day} />
          </mesh>
          <mesh

            geometry={nodes.Plane_4.geometry}
            material={nodes.Plane_4.material}
            position={[-0.001, -0.001, 0]}
            rotation={[0.496, 0.268, 0.455]}
            >
            <meshMatcapMaterial matcap={matCap2} color={props.isDark?colors.night:colors.day} />
          </mesh>
          <mesh

            geometry={nodes.Plane_5.geometry}
            material={nodes.Plane_5.material}
            position={[-0.001, 0.001, 0]}
            rotation={[0.496, -0.268, -0.455]}
            >
            <meshMatcapMaterial matcap={matCap2} color={props.isDark?colors.night:colors.day} />
          </mesh>
        </group>
        <meshMatcapMaterial matcap={matCap2} color={props.isDark?colors.night2:colors.day2} />
      </mesh>
      <mesh

        geometry={nodes.Extrude.geometry}
        material={nodes.Extrude.material}
        position={[0, 0.025, 0]}
        >
        <meshMatcapMaterial matcap={matCap2} color={props.isDark?colors.night:colors.day} />
      </mesh>
    </group>
  )
}

useGLTF.preload('/fan01.gltf')
